module.exports = require("./hi.d.ts");